import { render, staticRenderFns } from "./riskAssessmentAreasPreset.vue?vue&type=template&id=1214b08c"
import script from "./riskAssessmentAreasPreset.vue?vue&type=script&lang=js"
export * from "./riskAssessmentAreasPreset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports